import { Transforms, Editor, Node, Text, Range, BaseEditor, Path, Element } from 'slate'
import { ElementWithType } from '../../../../../../utils/types'
import { isInlineElement } from '../../../utils/queries'

import { LIST_TYPES } from '../../../elements/Element/list/utils'
import { isPathInRectangle } from '../../../elements'
import { checkIfSingleCellSelected } from '../../../elements/Element/table/utils/checkIfIsSelectionOnlyInTable'

export const toggleBlock = (editor, format) => {
  let isActive = isBlockActive(editor, format)
  const isList = LIST_TYPES.includes(format)
  removeStyle(editor);

  Editor.withoutNormalizing(editor, () => {


    Transforms.unwrapNodes(editor, {
      match: (n: any) => {
        return LIST_TYPES.includes(n.type)
      },
      split: true,
      mode: 'all',
    })

    Transforms.unwrapNodes(editor, {
      match: (n: any) => {
        return n.type === "li"
      },
      split: true,
      mode: 'all',
    })

  })



  if (isActive && isList) {
    isActive = false
  }

  let type;
  if (isActive) {
    type = 'p'
  } else if (isList) {
    type = 'li'
  } else {
    type = format
  }
  if(type !== 'code'){
  Transforms.setNodes(editor, {
    type: type,
  } as Partial<ElementWithType>)
}if (!isActive) {
  if (format === 'code' && editor.selection && Range.isExpanded(editor.selection)) {
    
    const { anchor, focus } = editor.selection
    
    const isPartialSelection = (!Editor.isStart(editor, anchor, anchor.path) && !Editor.isEnd(editor, anchor, anchor.path)) || 
                               (!Editor.isStart(editor, focus, focus.path) && !Editor.isEnd(editor, focus, focus.path))
    
    let text
    let preservedIndentLevel = null
    
    if (isPartialSelection) {
     
      const fragment = Editor.fragment(editor, editor.selection)
      text = fragment.map((node) => Node.string(node)).join('\n').trimStart().trimEnd()
    } else {
            const blockElements = []
      for (const [node, path] of Editor.nodes(editor, {
        at: editor.selection,
        match: (n: any) => !Text.isText(n) && !isInlineElement(n),
        mode: 'lowest'
      })) {
        const elementNode = node as ElementWithType
        if (preservedIndentLevel === null && elementNode.attrs?.['data-indent-level'] !== undefined) {
          preservedIndentLevel = elementNode.attrs['data-indent-level']
        }
    
        const textNodes = []
        for (const [textNode] of Editor.nodes(editor, {
          at: path,
          match: Text.isText,
          mode: 'lowest'
        })) {
          textNodes.push(textNode.text)
        }

        const blockText = textNodes.join('')
        blockElements.push(blockText)
      }
      
      text = blockElements.join('\n')
    }

    Transforms.delete(editor, { at: editor.selection })
    const codeAttrs: any = {
      language: 'html',
      ...editor.children[0].attrs
    }
    if (preservedIndentLevel !== null) {
      codeAttrs['data-indent-level'] = preservedIndentLevel
    }
    
    Transforms.insertNodes(editor, {
      type: 'code',
      attrs: codeAttrs,
      children: [{ text: text }]
    } as ElementWithType)

  }
  else {
    const nodesToUpdate: Array<{ path: any, indentLevel: number | undefined }> = []
    
    for (const [node, path] of Editor.nodes(editor, {
      at: editor.selection,
      match: (n: any) => !Text.isText(n) && !isInlineElement(n),
      mode: 'lowest'
    })) {
      const elementNode = node as ElementWithType
      const indentLevel = elementNode.attrs?.['data-indent-level']
      nodesToUpdate.push({ path, indentLevel })
    }
    
    for (const { path, indentLevel } of nodesToUpdate) {
      const preservedAttrs: any = {}
      if (indentLevel !== undefined) {
        preservedAttrs['data-indent-level'] = indentLevel
      }
      
      Transforms.setNodes(editor, {
        type: type,
        attrs: preservedAttrs
      } as Partial<ElementWithType>, { at: path })
    }
  }

}
  if (!isActive && format === 'check-list') {
    Transforms.setNodes(editor, { checked: false } as Partial<ElementWithType>)
  }
  if (!isActive && isList) {
    const block = { type: format, children: [] }
    Transforms.wrapNodes(editor, block)
  }
}

export const isBlockActive = (editor, format) => {
  const [match] = Editor.nodes(editor, {
    match: (n: ElementWithType) => n.type === format,
  })
  return !!match
}

export const toggleMark = (editor, format) => {
  const isActive = isMarkActive(editor, format)

  const cellEntries = getCellsInRectangle(editor)

  if (cellEntries) {
    for (let [, path] of cellEntries) {
      for (let [, textPath] of Node.texts(editor, { from: path, to: path })) {
        isActive
          ? Transforms.unsetNodes(editor, format, { at: textPath })
          : Transforms.setNodes(editor, { [format]: true }, { at: textPath })
      }
    }
    return
  }

  isActive ? Editor.removeMark(editor, format) : Editor.addMark(editor, format, true)
}

export const isMarkActive = (editor, format) => {
  try {
    const cellEntries = getCellsInRectangle(editor)
    if (cellEntries) {
      return Array.from(cellEntries).every(([, path]) => {
        return Array.from(Node.texts(editor, { from: path, to: path })).every(([textNode]) => {
          const { text, ...marks } = textNode
          return marks ? marks[format] === true : false
        })
      })
    }

    const marks = Editor.marks(editor)
    return marks ? marks[format] === true : false
  } catch (err) {
    if (err instanceof Error) {
      err.message = 'While getting marks: ' + err.message
      console.error(err, JSON.stringify({ selection: editor.selection, children: editor.children }))
    }
  }
}

function removeStyle(editor) {
  const matches = Array.from(Editor.nodes(editor, {
    match: (node, path) => {
      const hasStyle = !!(!Editor.isEditor(node) && !Text.isText(node) && node?.['attrs']?.['style']);
      return hasStyle;
    }
  }));
  matches.reverse().forEach(([node, path]) => {
    const attrs = Object.assign({}, node['attrs']);
    delete attrs['style'];
    Transforms.setNodes(editor, { attrs } as any, {
      at: path
    })
  })
}

function getCellsInRectangle(editor) {
  if (!editor.selection) return
  const [table] = Editor.nodes(editor, { at: editor.selection, match: (n) => n['type'] === 'table' })
  if (table) {
    const tablePath = table[1]
    const tableRange = Editor.range(editor, tablePath)

    const isSelectionOnlyInTable =
      Range.includes(tableRange, Range.start(editor.selection)) &&
      Range.includes(tableRange, Range.end(editor.selection))

    if (checkIfSingleCellSelected(editor)) return false

    if (isSelectionOnlyInTable) {
      const nodeEntries = Editor.nodes(editor, {
        match: (node, path) =>
          node['type'] === 'th' || (node['type'] === 'td' && isPathInRectangle(editor, path, tablePath))
      })

      return nodeEntries
    }
  }
}
